import {POST} from "@/services/gateway";

export const listSnapshotDetails = ({type, searchTerm, snapshotDateTime, pagination}) => {
  return POST('entra-id/search', {type, searchTerm, snapshotDateTime, pagination})
}

export const listSnapshots = ({date, dateTo}) => {
  return POST('entra-id/snapshot/list', {date, dateTo})
}
